import { ORDER_EXPIRY } from '@/common/constants'
import { OrderExpiry } from '@/common/types'
import { Label } from '@/common/ui'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/common/ui/select'
import { FC } from 'react'

type Props = {
    orderExpiry: OrderExpiry
    setOrderExpiry: (orderExpiry: OrderExpiry) => void
    labelClassName?: string
}

export const DurationSelector: FC<Props> = ({ orderExpiry, setOrderExpiry, labelClassName = '' }) => {
    return (
        <div className="flex flex-row justify-between items-center w-full">
            <div className={`text-left text-sm w-1/2 ${labelClassName}`}>
                <Label htmlFor="order-expiry">Expiry duration:</Label>
            </div>

            <div className="w-1/2 flex justify-end text-right">
                <Select value={orderExpiry} onValueChange={(expiry: OrderExpiry) => setOrderExpiry(expiry)}>
                    <SelectTrigger
                        id="order-expiry"
                        className="w-full text-right gap-2 rounded-full border border-gray-300 py-2 px-4 !mt-0 focus:ring-transparent justify-end"
                    >
                        <SelectValue placeholder="Select order expiry" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            <SelectItem value="VALID_TILL_EOD">{ORDER_EXPIRY['VALID_TILL_EOD']}</SelectItem>
                            <SelectItem value="VALID_FOR_DAYS_7">{ORDER_EXPIRY['VALID_FOR_DAYS_7']}</SelectItem>
                            <SelectItem value="VALID_FOR_DAYS_15">{ORDER_EXPIRY['VALID_FOR_DAYS_15']}</SelectItem>
                            <SelectItem value="VALID_FOR_DAYS_30">{ORDER_EXPIRY['VALID_FOR_DAYS_30']}</SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </div>
        </div>
    )
}
